"use client";

import React, { useRef, useState } from "react";
import { useRouter } from "next/navigation";
import { useJsApiLoader, Autocomplete } from "@react-google-maps/api";

const PlacesAutocompleteField = ({
  customErrorInputStyle = null,
  customErrorLabelStyle = null,
  customErrorMessageStyle = null,
  errorMessage = "",
  idField,
  inputClassName,
  isValid = true,
  label,
  labelClassName,
  name,
  onLoad,
  onPlaceChanged,
  placeholder,
  required,
  setValue,
  value,
}) => {
  const router = useRouter();
  const [libraries] = useState(["places", "drawing", "geometry"]);
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY,
    libraries: libraries,
  });

  const inputRef = useRef(null);

  // Handle the keypress for input
  const onKeypress = (e) => {
    // On enter pressed
    if (e.key === "Enter") {
      e.preventDefault();
      return false;
    }
  };

  const getInputStyles = (isValid, customErrorInputStyle) => {
    if (!isValid && customErrorInputStyle) {
      return customErrorInputStyle;
    }

    return {
      border: isValid ? "1px solid #ccc" : "1px solid #960000",
      background: isValid ? "" : "#f9f0f0",
    };
  };

  const getLabelStyle = (isValid, customErrorLabelStyle) => {
    if (!isValid && customErrorLabelStyle) {
      return customErrorLabelStyle;
    }

    return {
      color: isValid ? "" : "#960000",
    };
  };

  return (
    <>
      {loadError && (
        <div>
          Google Map script can&apos;t be loaded, please reload the page
        </div>
      )}

      {isLoaded && (
        <div className="tps-form-label">
          <label
            className={
              labelClassName
                ? labelClassName
                : "form-control tps-field-required tps-to-validate"
            }
            htmlFor={idField}
            style={getLabelStyle(isValid, customErrorLabelStyle)}
          >
            {label}
          </label>
          <Autocomplete
            onLoad={onLoad}
            fields={[
              "place_id",
              "name",
              "geometry",
              "formatted_address",
              "address_components",
            ]}
            restrictions={{ country: ["ca", "us"] }}
            onPlaceChanged={(value) => onPlaceChanged(value)}
          >
            <input
              className={inputClassName}
              style={getInputStyles(isValid, customErrorInputStyle)}
              ref={inputRef}
              type="text"
              id={idField}
              name={name}
              required={required}
              placeholder={placeholder}
              onKeyPress={onKeypress}
              value={value}
              onChange={setValue}
            />
          </Autocomplete>
          {!isValid && (
            <span
              className="EditingFormErrorLabel"
              style={customErrorMessageStyle}
            >
              {errorMessage}
            </span>
          )}
        </div>
      )}
    </>
  );
};
export default PlacesAutocompleteField;
